export const getPictureUrl = (picture?: string) => {
  if (!picture) return ''
  return picture
}
